import { ProductsActionTypes } from './products.types';

const requestAllProducts = () => ({ type: ProductsActionTypes.GET_ALL_PRODUCTS });
const getAllProductsFailure = () => ({ type: ProductsActionTypes.GET_ALL_PRODUCTS_FAILURE });
const getAllProductsSuccess = () => ({ type: ProductsActionTypes.GET_ALL_PRODUCTS_SUCCESS });
const setAllProductsList = list => ({ type: ProductsActionTypes.SET_ALL_PRODUCTS_LIST, payload: list });

const requestProductsPerCategory = ({ history }) => ({ type: ProductsActionTypes.REQUEST_GET_PRODUCTS, payload: { history } });
const getProductsSuccess = () => ({ type: ProductsActionTypes.GET_PRODUCTS_SUCCESS });
const getProductsSet = products => ({ type: ProductsActionTypes.GET_PRODUCTS_SET, payload: products });
const getProductsFailure = () => ({ type: ProductsActionTypes.GET_PRODUCTS_FAILURE });
const getProductById = productId => ({ type: ProductsActionTypes.GET_PRODUCT_BY_ID, payload: { productId } });
const setProductVisualized = (hostingId, productId) => ({ type: ProductsActionTypes.SET_PRODUCT_VISUALIZED, payload: { hostingId, productId } });
const setProductVisualizedFailure = () => ({ type: ProductsActionTypes.SET_PRODUCT_VISUALIZED_FAILURE });
const setCPanelSSOLoading = loading => ({ type: ProductsActionTypes.SET_CPANEL_LOADING, payload: loading });
const requestCPanelSSO = ({
  hostingId, defaultCPanelUrl, setLoadingWithId, backup, backupWizard, setLoadingCpanelSSOProductId, setBlockedWindowUrl,
  redirect,
}) => ({
  type: ProductsActionTypes.GET_CPANEL_LINK,
  payload: {
    hostingId,
    defaultCPanelUrl,
    setLoadingWithId,
    backup,
    backupWizard,
    setLoadingCpanelSSOProductId,
    setBlockedWindowUrl,
    redirect,
  },
});
const addToAlertsList = alertItem => ({ type: ProductsActionTypes.SET_ADD_ALERT, payload: alertItem });
const clearNewAlerts = alertsList => ({ type: ProductsActionTypes.REQUEST_CLEAR_NEW_ALERTS, payload: alertsList });
const setClearNewAlerts = payload => ({ type: ProductsActionTypes.SET_CLEAR_NEW_ALERTS, payload });
const setAlertsVisibility = payload => ({ type: ProductsActionTypes.SET_ALERTS_VISIBILITY, payload });
const addConsultedProduct = product => ({ type: ProductsActionTypes.SET_CONSULTED_PRODUCTS_LIST, payload: product });

const n8nRequest = ({ hostingId, actionType = null, callback = null }) => ({ type: ProductsActionTypes.GET_N8N_REQUEST, payload: { hostingId, actionType, callback } });
const n8nSet = ({ vpsData, hostingId }) => ({ type: ProductsActionTypes.GET_N8N_SET, payload: { vpsData, hostingId } });
const n8nFailure = () => ({ type: ProductsActionTypes.GET_N8N_FAILURE });

const actions = {
  products: {
    getProductById,
    request: requestProductsPerCategory,
    failure: getProductsFailure,
    success: getProductsSuccess,
    set: getProductsSet,
    requestAll: requestAllProducts,
    setRequestAllFailure: getAllProductsFailure,
    setRequestAllSuccess: getAllProductsSuccess,
    setAllProductsList,
    addConsultedProduct,
  },
  productsVisualized: {
    set: setProductVisualized,
    failure: setProductVisualizedFailure,
  },
  cPanelSSO: {
    loading: setCPanelSSOLoading,
    requestLink: requestCPanelSSO,
  },
  myAlerts: {
    add: addToAlertsList,
    clearNew: clearNewAlerts,
    setClear: setClearNewAlerts,
    setVisibility: setAlertsVisibility,
  },
  n8n: {
    request: n8nRequest,
    set: n8nSet,
    failure: n8nFailure,
  },
};

export default actions;
